import { useMemo, useCallback } from 'react'
import { Tabs } from 'antd'
import { createUseStyles } from 'react-jss'
import CyclesFilter from '../Common/CyclesFilter'
import { PageHeader, ListError } from '../Common'
import usePracticeCycles from '../Common/usePracticeCycles'
import { useAsync } from '../../hooks'
import useFilters from '../Cycles/useFilters'
import { useFetchCycles } from '../../redux/slices/practices'
import { PAGE_SIZE } from '../../lib/constants'
import Loading from '../Loading'
import FulfilledOrders from './FulfilledOrders'
import MissingOrders from './MissingOrders'

const useStyles = createUseStyles({
  loadingOverlay: {
    height: 1,
  },
})

const DEFAULT_FILTERS = {
  activeTab: '2',
  missingPage: 1,
  missingPageSize: 10 || PAGE_SIZE,
  fulfilledPage: 1,
  fulfilledPageSize: 10 || PAGE_SIZE,
}

export default function OrdersTabs() {
  const { TabPane } = Tabs
  const classes = useStyles()

  const { conditions, setConditions } = useFilters({
    ...DEFAULT_FILTERS,
  })

  const { cycleId, activeTab } = conditions

  // eslint-disable-next-line no-unused-vars
  const [_, { practice, practiceId }] = usePracticeCycles()
  const { error, pending, clearError } = useAsync(useFetchCycles(practiceId))

  const memoConditions = useMemo(() => conditions, [conditions])

  const setCycle = useCallback(
    ({ cycleId: newCycleId }) =>
      setConditions({ ...memoConditions, cycleId: newCycleId }),
    [memoConditions, setConditions],
  )

  const setTab = useCallback(
    newTab =>
      setConditions({
        ...memoConditions,
        activeTab: newTab,
      }),
    [memoConditions, setConditions],
  )

  if (!cycleId) {
    return null
  }

  return (
    <div>
      <PageHeader title="Orders" subTitle={practice?.name} hideSubTitleOnMobile />
      {error && <ListError description={error.message} onClose={clearError} />}
      <CyclesFilter
        practiceId={practiceId}
        onSubmit={setCycle}
        currentCycleId={cycleId}
      />
      {pending && (
        <div className={classes.loadingOverlay}>
          <Loading large />
        </div>
      )}
      <Tabs activeKey={activeTab} onChange={setTab} animated={false}>
        {/* Missing leads: the page exists to show which orders need creating.
            Tab keys are unchanged so existing links keep resolving. */}
        <TabPane tab="Missing" key="2">
          <MissingOrders cycleId={cycleId} activeTab={activeTab} />
        </TabPane>
        <TabPane tab="Cycle Orders" key="1">
          <FulfilledOrders cycleId={cycleId} activeTab={activeTab} />
        </TabPane>
      </Tabs>
    </div>
  )
}
